export default __webpack_public_path__ + "static/media/shield-gold.07cd5ba2.svg";